import React from 'react';
import { mediaQueries } from 'style/config';
import { wrapFunctionalComponent } from 'utils/framework';
import AccountLayout from 'components/RichProfile/MyAccount/AccountLayout/AccountLayout';
import AutoReplenishmentPageContent from 'components/RichProfile/MyAccount/AutoReplenishment/AutoReplenishmentPageContent';
import useAutoReplenishmentMain from 'components/RichProfile/MyAccount/AutoReplenishment/AutoReplenishmentMain/hooks/useAutoReplenishmentMain';

/**
 * Main Auto Replenishment component.
 * Renders the Auto Replenishment page within the Account Layout.
 * Loads Contentful content on mount if the empty hub feature flag is enabled.
 *
 * @returns {React.Element} The Auto Replenishment main content wrapped in AccountLayout
 */
const AutoReplenishmentMain = () => {
    const { localization } = useAutoReplenishmentMain();

    return (
        <AccountLayout
            section='account'
            page='autoReplenishment'
            title={localization.pageTitle}
            customCss={{ main: styles.main }}
        >
            <AutoReplenishmentPageContent />
        </AccountLayout>
    );
};

const styles = {
    main: {
        [mediaQueries.xsMax]: {
            minHeight: '100vh'
        }
    }
};

export default wrapFunctionalComponent(AutoReplenishmentMain, 'AutoReplenishmentMain');
